import React from 'react';
import { Control } from 'react-hook-form';
import { BaseCard, BaseCardProps } from '@/components/uiKit/Cards';
import { FormInput } from '../FormInput';
import { UserProfileFormData } from '@/components/pages/SettingsPage/MainContent/shared/UserDetailsForm/UserDetailsForm';
import { useTranslation } from 'react-i18next';

interface ProfileSectionProps {
  control: Control<UserProfileFormData, any>;
}

export const ProfileSection = ({ control }: ProfileSectionProps) => {
  const { t } = useTranslation();
  return (
  <BaseCard
    variant="wrapper"
    classNames={{
      card: `w-full`,
      title: 'h-[30px]',
      content: 'h-[calc(100%-30px)] rounded-lg overflow-y-hidden flex flex-row p-6',
    }}
    title={t('userDetailsForm.profile.title')}
  >
    <div className="flex flex-col w-1/2 gap-4">
      <div className="flex flex-row w-full gap-4">
        <div className="flex-1">
          <FormInput
            name="first_name"
            control={control}
            label={t('userDetailsForm.profile.firstName.label')}
            rules={{ required: t('userDetailsForm.profile.firstName.required') }}
          />
        </div>
        <div className="flex-1">
          <FormInput
            name="last_name"
            control={control}
            label={t('userDetailsForm.profile.lastName.label')}
            rules={{ required: t('userDetailsForm.profile.lastName.required') }}
          />
        </div>
      </div>
      <div className="flex flex-row w-full gap-4">
        <div className="flex-1">
          <FormInput
            name="phone_number"
            control={control}
            label={t('userDetailsForm.profile.phone.label')}
            rules={{
              pattern: {
                value: /^\+[1-9]\d{1,15}$/,
                message: t('userDetailsForm.profile.phone.invalid'),
              },
            }}
          />
        </div>
        <div className="flex-1">
          <FormInput
            name="email"
            control={control}
            label={t('userDetailsForm.profile.email.label')}
            rules={{
              required: t('userDetailsForm.profile.email.required'),
              pattern: {
                value: /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/,
                message: t('userDetailsForm.profile.email.invalid'),
              },
            }}
          />
        </div>
      </div>
    </div>
  </BaseCard>
  );
};
